import { ContextStylesParams, CSSObject } from '@mantine/core'

const SIZES = {
    xs: {
        width: '1.6rem',
        height: '1.6rem'
    },
    sm: {
        width: '2rem',
        height: '2rem'
    },
    md: {
        width: '2.4rem',
        height: '2.4rem'
    },
    lg: {
        width: '3.2rem',
        height: '3.2rem'
    },
    xl: {
        width: '4rem',
        height: '4rem'
    }
}

export const getActionIconStyles = (props: ContextStylesParams): Record<string, CSSObject> => {
    const style = SIZES[props?.size] || {}

    return {
        root: {
            ...style
        }
    }
}
